import { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import MobileStepper from '@mui/material/MobileStepper';
import SwipeableViews from 'react-swipeable-views';

const useStyles = makeStyles()({
    root: {
        background: 'none',
        alignItems: 'center',
        justifyContent: 'center'
    }
});

const Carousel = (props) => {
    const { children } = props;
    const { classes } = useStyles();
    const [activeStep, setActiveStep] = useState(0);

    const handleIndexChange = (index) => setActiveStep(index);

    return (
        <>
            <SwipeableViews index={activeStep} onChangeIndex={handleIndexChange} enableMouseEvents>
                {children}
            </SwipeableViews>
            <MobileStepper
                variant="dots"
                steps={children.length}
                position="static"
                activeStep={activeStep}
                className={classes.root}
            />
        </>
    );
};

export default Carousel;
